export const LanugageConfig = [
  { flag: "ar", language: "ar", name: "عربي" },
  { flag: "bg", language: "bg", name: "български" },
  { flag: "en", language: "en", name: "English" },
  { flag: "cn", language: "zh-CN", name: "中文（简体）" },
  { flag: "cz", language: "cs", name: "čeština" },
  { flag: "fr", language: "fr", name: "Français" },
  { flag: "de", language: "de", name: "Deutsch" },
  { flag: "el", language: "el", name: "ελληνικά" },
  { flag: "hu", language: "hu", name: "magyar" },
  { flag: "id", language: "id", name: "Indonesia" },
  { flag: "it", language: "it", name: "Italiano" },
  { flag: "jp", language: "ja-JP", name: "日本語" },
  { flag: "kr", language: "ko-KR", name: "한국인" },
  { flag: "pl", language: "pl", name: "Polski" },
  { flag: "pt", language: "pt", name: "Português" },
  { flag: "ro", language: "ro", name: "română" },
  { flag: "ru", language: "ru", name: "Русский" },
  { flag: "es", language: "es", name: "Español" },
  { flag: "th", language: "th", name: "แบบไทย" },
  { flag: "tr", language: "tr", name: "Türkçe" },
];
